//@ts-nocheck

/**
 * Waliduje dane zamówienia
 * @param {string} selectedProducer - Wybrany producent
 * @param {Object} orderItems - Obiekt z zamawianymi produktami
 * @returns {Object} Obiekt z wynikiem walidacji
 */
export const validateOrderData = (selectedProducer, orderItems) => {
  const errors = [];

  if (!selectedProducer || selectedProducer.trim() === '') {
    errors.push('Wybierz producenta');
  }

  const itemsToOrder = Object.entries(orderItems)
    .filter(([_, quantity]) => quantity > 0)
    .map(([productId, quantity]) => ({
      itemId: productId,
      quantity: parseInt(quantity, 10),
    }));

  if (itemsToOrder.length === 0) {
    errors.push('Wybierz przynajmniej jeden produkt do zamówienia');
  }

  return {
    isValid: errors.length === 0,
    errors,
    itemsToOrder,
  };
};

/**
 * Formatuje cenę do wyświetlenia
 * @param {number} price - Cena do sformatowania
 * @returns {string} Sformatowana cena
 */
export const formatPrice = (price) => {
  return (price || 0).toFixed(2);
};
